import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faBolt, faLock, faMobileAlt, faBell, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { SectionTitle, NumberedList } from '../../../components/apidocs';

const OverviewSection: React.FC = () => {
  const { t } = useTranslation();

  const features = [
    { icon: faBolt, title: t('apiDocs.featureFast'), desc: t('apiDocs.featureFastDesc'), gradient: 'from-amber-400 to-orange-500' },
    { icon: faLock, title: t('apiDocs.featureSecure'), desc: 'HMAC-SHA256 Signature', gradient: 'from-emerald-400 to-teal-500' },
    { icon: faMobileAlt, title: 'QR Code', desc: t('apiDocs.featureQrDesc'), gradient: 'from-sky-400 to-blue-500' },
    { icon: faBell, title: 'Webhook', desc: t('apiDocs.featureWebhookDesc'), gradient: 'from-violet-400 to-purple-500' },
  ];

  return (
    <div>
      <SectionTitle icon={faStar} iconColor="bg-gradient-to-br from-amber-400 to-orange-500">
        Welcome to Payment Gateway API
      </SectionTitle>
      <p className="text-gray-500 dark:text-slate-400 mb-8 leading-relaxed text-sm">
        {t('apiDocs.overviewDesc')}
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {features.map((f, idx) => (
          <div key={idx} className="api-docs-glow-card group bg-white dark:bg-slate-800 rounded-xl p-5 border border-gray-200/60 dark:border-slate-700 hover:border-gray-300/80 dark:hover:border-slate-600 hover:shadow-lg transition-all duration-300 cursor-default">
            <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${f.gradient} text-white flex items-center justify-center text-lg mb-3 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
              <FontAwesomeIcon icon={f.icon} />
            </div>
            <h3 className="font-bold text-gray-800 dark:text-slate-100 text-sm mb-1">{f.title}</h3>
            <p className="text-xs text-gray-500 dark:text-slate-400 leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </div>

      <div className="bg-gradient-to-br from-indigo-50 via-blue-50 to-sky-50 dark:from-slate-700/40 dark:via-slate-700/40 dark:to-slate-700/40 rounded-xl p-6 border border-indigo-200/50 dark:border-slate-700">
        <h3 className="text-base font-bold text-indigo-800 dark:text-indigo-300 flex items-center gap-2 mb-4">
          <FontAwesomeIcon icon={faArrowRight} className="text-indigo-500" /> Quick Start
        </h3>
        <NumberedList
          items={[t('apiDocs.quickStep1'), t('apiDocs.quickStep2'), t('apiDocs.quickStep3'), t('apiDocs.quickStep4')]}
        />
      </div>
    </div>
  );
};

export default OverviewSection;
